/* eslint-disable @typescript-eslint/no-unused-vars */
import { useEffect, useState } from 'react';
import styles from './styles.module.scss';
import Chip from 'components/common/Chip';
import BottomSpace from 'components/common/BottomSpace';
import { useTranslation } from 'react-i18next';
import { Image, Skeleton } from 'antd-mobile';
import { useParams } from 'react-router';
import { getBuildingDetail, getPartnerDetail, getRoomDetail } from 'services/property.service';
import { delayNavigate, formatDate, formatPrice, isSuccessCode, showData } from 'utils/common';
import { BranchType, BuildingInfoType, RoomType } from '@/types/property.type';

type Props = {};

export default function DetailRoomContainer({}: Props) {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const { roomId, branchId, buildingId } = useParams();
  const [roomInfo, setRoomInfo] = useState<RoomType>();
  const [buildingInfo, setBuildingInfo] = useState<BuildingInfoType>();
  const [branchInfo, setBranchInfo] = useState<BranchType>();

  const getRoomDetailInfo = async () => {
    const response = await getRoomDetail({ roomId });
    const { data, code } = response.data;
    if (isSuccessCode(code)) {
      setRoomInfo(data);
    }
  };

  const getBuildingDetailInfo = async () => {
    const response = await getBuildingDetail({ buildingId, branchId });
    const { data, code } = response.data;
    if (isSuccessCode(code)) {
      setBuildingInfo(data);
    }
  };

  const getBranchDetailInfo = async () => {
    const response = await getPartnerDetail({ branchId });
    const { data, code } = response.data;
    if (isSuccessCode(code)) {
      setBranchInfo(data);
    }
  };

  const initCallApi = async () => {
    await Promise.all([getRoomDetailInfo(), getBuildingDetailInfo(), getBranchDetailInfo()]);
    delayNavigate(() => setIsLoading(false));
  };

  useEffect(() => {
    initCallApi();
  }, [roomId, branchId, buildingId]);

  return (
    <div className={styles.wrapper}>
      {isLoading && <Skeleton.Paragraph animated lineCount={16} />}
      {!isLoading && (
        <>
          <p
            className="color-black font-xl font-bold"
            style={{ textAlign: 'left', lineHeight: 'var(--font-xxl)' }}
          >
            {t('title.contact-information')}
          </p>

          <div className={styles.contact}>
            <div className={styles.branchInfo}>
              <div className={styles.buildingLogo}>
                <Image src={branchInfo?.branchDetail?.appLogo || ''} />
              </div>
              <div className={styles.overview}>
                <p className="font-bold font-sm color-grey-01">
                  {t('title.partner')}:{' '}
                  <span className="color-black">{showData(branchInfo?.name)}</span>
                </p>
                <p className="font-bold font-sm color-grey-01">
                  {t('title.building')}:{' '}
                  <span className="color-black">{showData(buildingInfo?.name)}</span>
                </p>
              </div>
            </div>
            <p className="font-bold font-sm color-grey-01">
              {t('title.location')}:{' '}
              <span
                className="color-black"
                style={{
                  lineHeight: '18px',
                }}
              >
                {[
                  buildingInfo?.address,
                  buildingInfo?.district?.name,
                  buildingInfo?.province?.name,
                ].join(', ')}
              </span>
            </p>
            <p className="font-bold font-sm color-grey-01">
              {t('title.owner')}:{' '}
              <span className="color-black">{`${showData(branchInfo?.owner?.fullName)} - ${showData(
                branchInfo?.owner?.phoneNumber,
              )}`}</span>
            </p>
            <p className="font-bold font-sm color-grey-01">
              {t('title.note')}:{' '}
              <span
                className="color-black"
                style={{
                  whiteSpace: 'pre-wrap',
                  lineHeight: '18px',
                }}
              >
                {showData(buildingInfo?.note)}
              </span>
            </p>
          </div>
          <p
            className="color-black font-xl font-bold"
            style={{ textAlign: 'left', lineHeight: 'var(--font-xxl)' }}
          >
            {t('title.room-information')}
          </p>
          {/* <div className={styles.imageList}>
            <ImageView />
          </div> */}
          <div className={styles.roomInfo}>
            <div className={styles.block}>
              <p className="font-bold font-sm color-grey-01">{t('title.room')}:</p>
              <span className="font-bold font-sm color-blacks">{showData(roomInfo?.name)}</span>
            </div>
            <div className={styles.block}>
              <p className="font-bold font-sm color-grey-01">{t('title.checkout-date')}:</p>
              {roomInfo?.latestBooking ? (
                <span className="font-bold font-sm color-red">
                  {formatDate(roomInfo?.latestBooking?.endDate)}
                </span>
              ) : (
                <Chip content={t('title.empty-room')} color="success" />
              )}
            </div>
            <div className={styles.block}>
              <p className="font-bold font-sm color-grey-01">{t('title.room-fee')}:</p>
              <Chip content={formatPrice(Number(roomInfo?.price) || 0)} color="warning" />
            </div>
            <p className="font-bold font-sm color-grey-01">
              {t('title.note')}:{' '}
              <span
                className="color-black"
                style={{
                  whiteSpace: 'pre-wrap',
                  lineHeight: '18px',
                }}
              >
                {showData(roomInfo?.note)}
              </span>
            </p>
          </div>
        </>
      )}
      <BottomSpace />
    </div>
  );
}
